import { Link } from 'react-router-dom'
const Booking = () => {
  return (
    <div className="Pages">
    <h1>Make an appointment</h1>
    <a href="https://calendly.com/obermanfinancialcoach">Book your free initial consultation</a>
    <br></br>
    <p>Enjoy a free 30-minute initial consultation.  In this consultation, we will get to know each other, determine if and how I can help and
    make a plan to get you on your way to financial victory!</p>
    <p>Please be sure to check out our <Link to="/services">services.</Link></p>
  </div>
  );
};

export default Booking;
